import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import Preview from '../../preview';
import MemberProvider from '../../providers/member';
import PostalProvider from '../../providers/postal';
import StoreProvider from '../../providers/store';
import TriggerbeeProvider from '../../providers/Triggerbee';
import Cell from '../../SiteContext/Cell';
import { GlobalStyle } from '../../styled/layout/global-style';
import Head from '../Head';
import PageLoader from '../PageLoader';
import CookieConsent from '../CookieConsent';
import { CartProvider } from '../../providers/cart';
import SofaBuilderLauncher from '../SofaBuilder/Launcher';
import { TokenValidation } from '../TokenValidation';
import Chat from '../Chat';
import AlertBanner from '@components/AlertBanner';

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: any, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Number.MAX_VALUE,
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const Layout = () => {
  return (
    <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
      <QueryClientProvider client={queryClient}>
        <MemberProvider>
          <PostalProvider>
            <StoreProvider>
              <TriggerbeeProvider>
                <CartProvider>
                  {/* @ts-ignore - We can resolve this when we update the dependencies/types */}
                  <GlobalStyle />
                  <Head />
                  <Cell id="header" />
                  <div className="main-content" style={{ position: 'relative' }}>
                    <Chat />
                    <AlertBanner />
                    <Cell id="main" />
                    <PageLoader />
                  </div>
                  <Cell id="footer" />
                  <CookieConsent />
                  <Preview />
                  <SofaBuilderLauncher />
                  <TokenValidation />
                </CartProvider>
              </TriggerbeeProvider>
            </StoreProvider>
          </PostalProvider>
        </MemberProvider>
      </QueryClientProvider>
    </StyleSheetManager>
  );
};

export default Layout;
